import {UserIconLarge} from "../Icons/UserLarge";
import styled from "styled-components/macro";
import {CopyHelper, ThemedText} from "../../theme";
import {Copy} from "react-feather";
import {shortenAddress} from "../../nft/utils/address";
import {useAccount, useEnsName} from "wagmi";
import {useDisconnect} from "../../connection/wallet-connect";
import {ButtonOutlined, ButtonPrimary} from "../Button";
import {CircularCloseIcon} from "../../nft/components/icons";

const Wrapper = styled.div`
  margin-top: 8px;
  padding: 24px;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 324px;
  background-color: ${({ theme }) => theme.backgroundModule};
  box-shadow: ${({ theme }) => theme.deepShadow};
  border-radius: 16px;
`

const CloseButton = styled(ButtonOutlined)`
  position: absolute;
  top: 24px;
  right: 32px;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.borderPrimaryHover};
  border-radius: 50%;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const Title = styled.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.01em;
  text-align: center;
`

const CopyWrapper = styled(ThemedText.SubHeader)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.background};
  border-radius: 7px;
`

const CopyText = styled(CopyHelper).attrs({
  InitialIcon: Copy,
  gap: 4,
  iconSize: 14,
  iconPosition: 'right',
})``

type Props = {
  onClose: () => void
}

export const AccountPopoverDetails = ({ onClose }: Props) => {
  const { address } = useAccount()
  const { data: ENSName } = useEnsName()
  const { disconnectAsync } = useDisconnect()

  const disconnectWallet = async () => {
    await disconnectAsync?.();
    onClose()
  }

  if (!address) return null

  return (
    <Wrapper>
      <CloseButton onClick={onClose}>
        <CircularCloseIcon />
      </CloseButton>
      <UserIconLarge />
      <Title>
        Account
      </Title>
      <Content>
        <CopyWrapper color="textPrimary" fontWeight={500}>
          <CopyText fontSize={16} toCopy={ENSName ?? address}>{ENSName ?? shortenAddress(address, 8, 8)}</CopyText>
        </CopyWrapper>
        <ButtonPrimary onClick={disconnectWallet}>Log out</ButtonPrimary>
      </Content>
    </Wrapper>
  );
};
